import { render, staticRenderFns } from "./CodMessage.vue?vue&type=template&id=226b3056&scoped=true&"
import script from "./CodMessage.vue?vue&type=script&lang=js&"
export * from "./CodMessage.vue?vue&type=script&lang=js&"
import style0 from "./CodMessage.vue?vue&type=style&index=0&id=226b3056&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226b3056",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('226b3056')) {
      api.createRecord('226b3056', component.options)
    } else {
      api.reload('226b3056', component.options)
    }
    module.hot.accept("./CodMessage.vue?vue&type=template&id=226b3056&scoped=true&", function () {
      api.rerender('226b3056', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Message/components/CodMessage.vue"
export default component.exports